import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import middleware from './middleware'

Vue.use(VueRouter)

const routes = [{
        path: '/postulados',
        name: 'home',
        component: HomeView,
        meta: { roles: ['CORE_ARCHITECT', 'STRATEGIC_DIRECTOR', 'AUDIT_SENTINEL'] },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/auth/LoginView.vue')
    },
    {
        path: '/usuarios',
        name: 'users',
        meta: { roles: ['CORE_ARCHITECT'] },
        component: () => import('@/views/users/UsersView.vue')
    },
    {
        path: '/jurado',
        name: 'jury',
        meta: { roles: ['CORE_ARCHITECT', 'STRATEGIC_DIRECTOR', 'EXPERT_EVALUATOR'] },
        component: () => import('@/views/jury/JuryView.vue')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: { roles: ['CORE_ARCHITECT', 'STRATEGIC_DIRECTOR'] },
        component: () => import('@/views/jury/DashboardView.vue')
    },
    {
        path: '/cambiar-contrasena',
        name: 'changePassword',
        meta: { roles: ['CORE_ARCHITECT', 'STRATEGIC_DIRECTOR', 'EXPERT_EVALUATOR', 'AUDIT_SENTINEL'] },
        component: () => import('@/views/auth/ChangePasswordView.vue')
    },
    {
        path: '/recuperar',
        name: 'recuperar',
        meta: { public: true },
        component: () => import('@/views/auth/RecoverView.vue')
    },
    {
        path: '/recoverView/:token?',
        name: 'recoverView',
        meta: { public: true },
        component: () => import('@/views/auth/RecoverView.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// Guard global que valida autenticación, WebSocket y roles por ruta
router.beforeEach(middleware.verificador);

// Silenciar el error de navegación duplicada (NavigationDuplicated)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err?.name !== 'NavigationDuplicated') throw err;
    });
};

export default router